module.exports = __webpack_public_path__ + "static/media/logo_green2get_40@2x.1cda01df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_green2get_40@2x.png
// module id = 3794
// module chunks = 0